import RecurringInviteSerializer, { RECURRING_INVITE_SERIALIZE_FALSE_ATTRS } from './recurring-invite';

// Inherits the meta.reason injection (serializeIntoHash); also drops recurring-rule, which the
// one-off resource forbids (the schedule is derived server-side from split-occurrence-date).
export default class RecurringInviteOneOffSerializer extends RecurringInviteSerializer {
  attrs = { ...RECURRING_INVITE_SERIALIZE_FALSE_ATTRS, recurringRule: { serialize: false } };
}
